export default __webpack_public_path__ + "static/media/Een EDO-project onder de loep.2383731a.zip";